import React from 'react';
import {SearchProduct} from 'components/search-product';
import {MasterLayout} from 'components/layouts';
import title from 'constants/TitlePages.js';

class SearchProductPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.SearchProductPage;
  }

  render() {
    return (
      <MasterLayout>
        <SearchProduct params={this.props.match.params} />
      </MasterLayout>
    );
  }
}

export default SearchProductPage;



// WEBPACK FOOTER //
// ./pages/search-product/SearchProductPage.jsx